import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, Col, FormFeedback } from 'reactstrap';
import TextArea from 'react-expanding-textarea';

const FormControl = ({
  children,
  className,
  id,
  input,
  label,
  meta: { touched, error },
  placeholder,
  rows,
  type,
}) => {
  let validationState = null;
  let errorText = null;

  if (touched) {
    if (error) {
      validationState = 'danger';
      errorText = error;
    } else {
      validationState = 'success';
    }
  }

  return (
    <FormGroup row color={validationState} className="form-group-2col">
      <Label for={id} sm={3} xs={12}>
        {label}
      </Label>
      <Col sm={8} md={6} xs={12}>
        {type === 'TextArea' ? (
          <TextArea
            {...input}
            id={id}
            placeholder={placeholder}
            className={`form-control ${className}`}
          />
        ) : (
          <Input {...input} id={id} type={type} rows={rows} placeholder={placeholder} />
        )}
        {children}
        <FormFeedback>{errorText}</FormFeedback>
      </Col>
    </FormGroup>
  );
};

FormControl.propTypes = {
  input: PropTypes.shape({}),
  id: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  rows: PropTypes.number,
  meta: PropTypes.shape({}),
  children: PropTypes.shape({}),
  className: PropTypes.string,
};

FormControl.defaultProps = {
  className: '',
};

export default FormControl;
